import { useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import {
	DatadogLogger,
	LoggerMessages,
	LoggerServices,
} from '~shared/services/logger';

import { MessageErrorBoundary } from '../MessageErrorBoundary';
import type { Props } from '../MessageItem';
import MessageItem from '../MessageItem';

const MessageItemWithErrorBoundary = ({ userId, message, ...props }: Props) => {
	const logError = (error: Error) => {
		DatadogLogger.error(
			LoggerServices.ChatService,
			LoggerMessages.RenderMessageError,
			{ error, message, userId }
		);
	};

	const isUserMessage = useMemo(() => {
		return userId === message.sender;
	}, [userId, message.sender]);

	const fallback = (
		<MessageErrorBoundary id={message.tag} isUserMessage={isUserMessage} />
	);

	return (
		<ErrorBoundary fallback={fallback} onError={logError}>
			<MessageItem userId={userId} message={message} {...props} />
		</ErrorBoundary>
	);
};

export default MessageItemWithErrorBoundary;
